import { Component, Input, OnDestroy } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import { debounceTime, filter, takeUntil } from "rxjs/operators";
import { AvanoTableFilteringService } from "../avano-table-filtering.service";

  
@Component({
  selector: 'avano-text-input-column-filter',
  template: `
  <input
    type="text"
    (keydown.enter)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
    [(ngModel)]="inputValue"
    class="p-inputtext"
    style="width: 100%"
  />
  `
})
export class TextInputColumnFilterComponent implements OnDestroy {
  @Input() debounceTimeInMs = 300;
  @Input() minInputLength = 2;
  @Input() filterMatchMode = 'contains';
  @Input() filterField: string;

  private _inputValue = "";
  set inputValue(newValue: string) {
    if (newValue !== this._inputValue) {
      this._inputValue = newValue;
      this.debounceUserInput(newValue);
    }
  }
  get inputValue() { return this._inputValue; }

  private destroyed$: ReplaySubject<void> = new ReplaySubject(1);
  
  private filterInputDebouncer = new Subject<string>();
  private filterInput$ = this.filterInputDebouncer.pipe(
    filter(input => input.length >= this.minInputLength || input == ''),
    debounceTime(this.debounceTimeInMs),
    takeUntil(this.destroyed$)
  ) 

  constructor(filteringService: AvanoTableFilteringService) {
    this.filterInput$.pipe(takeUntil(this.destroyed$)).subscribe((filterValue) => {
      filteringService.applyFilter(filterValue, this.filterField, this.filterMatchMode)
    })
    filteringService.resetFilters$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.inputValue = '';
    })
  }

  debounceUserInput(userInput: string) {
    this.filterInputDebouncer.next(userInput);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}